import { Inject, Optional, Injectable, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import {Observable, Subject, of, BehaviorSubject, throwError } from 'rxjs';
import { map, filter, scan, catchError, tap} from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { MessageService } from '../message.service';
import {AUTH_ENABLED} from '../../app.tokens';

let headers  = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
headers = headers.set('Accept', 'application/json');

const httpOptions = {
  headers: headers
};

const STORAGE_KEY = 'USER';

export class LocalUser implements User {

  static create(data: any) {
    return new LocalUser(data.uuid, data.firstName, data.lastName, data.userName, data.password, data.rights);
  }

  constructor( public uuid?: string,
               public firstName?: string,
               public lastName?: string,
               public username?: string,
               public password?: string,
               public rights?: string[]) {
  }

  hasRight(right: string) {
    this.rights =  this.rights || [];
    return this.rights.find(elem => elem === right) !== null
      && this.rights.find(elem => elem === right) !== undefined;
  }
}

@Injectable()
export class LoginService {
  private loginUrl = 'https://apimain.gerd-gruber.de/api/login_check';  // URL to web api
  private apiStartUrl = 'https://apimain.gerd-gruber.de/apiseppo';  // URL to web api

  constructor(private http: HttpClient,
              private messageService: MessageService) {
  }
//  curl -X POST -H "Content-Type: application/json" https://apimain.gerd-gruber.de/api/login_check -d '{"username":"ggruber1","password":"weckseiner"}'

  loginToAPI(userName: string, password: string) {
    let headers  = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
    headers = headers.set('Accept', 'application/json');

    let loginParams = new HttpParams();
    loginParams = loginParams.append('username', userName);
    loginParams = loginParams.append('password', password);
    let actualUser = new LocalUser('', '', '', userName, password);

    let httpOptions = {
      headers: headers
    };

    const url = `${this.loginUrl}`;
    return this.http.post(url, actualUser, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  showApistart(jwtToken: string) {
    let headers  = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
    headers = headers.set('Authorization', 'Bearer ' + jwtToken );
    headers = headers.set('Accept', 'application/json');

    let httpOptions = {
      headers: headers
    };

    const url = `${this.apiStartUrl}`;
    return this.http.get(url, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }

    return of(error.error);
  }
}
